import AdministrativePanelOptions from './AdministrativePanelOptions'
import SubMenu from '../common/SubMenu'

const AdministrativePanel = () => (
    <SubMenu componentOptions={AdministrativePanelOptions} />
)

export default AdministrativePanel